const AudienceTypes = Object.freeze({
  meta: 1,
  google: 2
})

export { AudienceTypes }



// WEBPACK FOOTER //
// ./src/modules/automations/enum/ExternalAudienceTypeEnum.js